import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import "./portfolioDetail.css";
import Mchat from "../../assets/images/chatappM.png";
import { projectData } from "./Data";

const PortfolioDetail = () => {
  const [title, setTitle] = useState("");
  const [description, setDescription] = useState("");
  const [githubLink, setGithubLink] = useState("");
  const [image, setImage] = useState(Mchat);
  const { url } = useParams();

  useEffect(() => {
    const formattedText = url
      .replace(/_/g, " ")
      .replace(/\b\w/g, (c) => c.toUpperCase());
    const projectDetails = projectData[`${formattedText}`];
    if (projectDetails) {
      setTitle(projectDetails.title);
      setDescription(projectDetails.description);
      setGithubLink(projectDetails.githubLink);
      setImage(projectDetails.image);
    } else {
      setTitle("Default Project");
      setDescription("This is the default project description.");
      setGithubLink("#");
      setImage(Mchat);
    }
  }, [url]);

  return (
    <div className="portfolio-detail">
      <div className="title">
        <h1>{title}</h1>
      </div>
      <div className="content">
        <div className="left-section">
          <p className="description-text">{description}</p>
          <div className="github-link">
            <a
              href={githubLink}
              target="_blank"
              className="btn btn-primary"
              rel="noopener noreferrer"
            >
              View on GitHub
            </a>
          </div>
        </div>
        <div className="right-section">
          <img src={image} alt={title} />
        </div>
      </div>
    </div>
  );
};

export default PortfolioDetail;

// <div className="features">
//         <h2>Features</h2>
//         <div className="feature">
//           <div className="image"></div>
//           <div className="text">
//             <p>
//               Feature description goes here. Explain what this feature does and
//               its significance.
//             </p>
//           </div>
//         </div>
//         <div className="feature">
//           <div className="image"></div>
//           <div className="text">
//             <p>
//               Feature description goes here. Explain what this feature does and
//               its significance.
//             </p>
//           </div>
//         </div>
//       </div>
//       <div className="run-code">
//         <h2>Run the Code</h2>
//         <p>
//           Add instructions or code snippets here to guide users on how to run or
//           interact with your project.
//         </p>
//       </div>
